import { useLocation, useMatches } from "@remix-run/react";
import { useMemo } from "react";

/**
 * Path the visitor should see after `?location=current`.
 * `history.replaceState` updates the address bar, but React Router still
 * reports the page they landed on. Breadcrumbs and the search field must
 * follow the rewritten city path instead.
 */
export function useDisplayedLocation() {
  const location = useLocation();
  const matches = useMatches();

  const currentLocationPath = useMemo(() => {
    for (let i = matches.length - 1; i >= 0; i -= 1) {
      const data = matches[i]?.data as { currentLocationPath?: unknown } | undefined;
      if (typeof data?.currentLocationPath === "string" && data.currentLocationPath) {
        return data.currentLocationPath;
      }
    }
    return "";
  }, [matches]);

  return useMemo(() => {
    if (!currentLocationPath) return location;
    const pathname = currentLocationPath.split("?")[0] || location.pathname;
    return { ...location, pathname, search: "" };
  }, [location, currentLocationPath]);
}
